import { View } from "@react-pdf/renderer";
import {
  ResumePDFSection,
  ResumePDFDescription,
} from "components/Resume/ResumePDF/common";
import { TemplateTwoPDFSection } from "./common";
import { styles } from "components/Resume/ResumePDF/styles";
import type { ResumeCustom } from "lib/redux/types";

export const Custom = ({
  heading,
  custom,
  themeColor,
  enableMistakeHighlight = false,
}: {
  heading: string;
  custom: ResumeCustom;
  themeColor: string;
  enableMistakeHighlight?: boolean;
}) => {
  const { descriptions } = custom;

  return (
    <TemplateTwoPDFSection themeColor={themeColor} heading={heading}>
      <View style={{ ...styles.flexRow }} wrap={false}>
        <View style={{ width: "30%" }}></View>
        <View style={{ width: "70%" }}>
          <ResumePDFDescription 
            items={descriptions} 
            enableMistakeHighlight={enableMistakeHighlight}
            section="custom"
            itemIndex={null}
          />
        </View>
      </View>
    </TemplateTwoPDFSection>
  );
};
